import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import SubscribeToNewsletter from "./SubscribeToNewsletter";
import Icon from "../../../components/Library/Icon/Icon";
import { updateUnAuthedSubscriptions, updateUserSubscriptions } from "../../../actions/user";
import { getLocalItem, setLocalItem } from "../../../utils/localdb";

import styles from "./AuthorSubscribe.css";

class AuthorSubscribe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alreadySubscribedTo: [],
      subscriptions: null,
      subscribing: false,
      thanks: false,
      index: 0,
    };
  }

  componentDidMount() {
    if (!this.props.isLoggedIn) {
      const alreadySubscribedTo = getLocalItem("AxiosSubscriptions");
      this.setState({ alreadySubscribedTo: alreadySubscribedTo || [] });
    }
    else if (this.props.user) {
      this.setState({ alreadySubscribedTo: this.props.user.subscriptions.map((s) => s.id) });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isLoggedIn && !this.props.user && nextProps.user) {
      this.setState({ alreadySubscribedTo: nextProps.user.subscriptions.map((s) => s.id) });
    }
  }

  onSubscribed = (email, subscription) => {
    if (this.props.isLoggedIn) {
      this.props.updateUserSubscriptions(this.props.user.subscriptions, subscription);
    } else {
      this.props.updateUnAuthedSubscriptions(email, [subscription.id])
        .then(() => {
          setLocalItem(
            "AxiosSubscriptions",
            [
              ...(getLocalItem("AxiosSubscriptions") || []),
              this.props.subscription.id,
            ],
            { expires: 30 }
          );
        });
    }
    this.setState({
      subscribing: false,
      thanks: !this.props.isLoggedIn,
      alreadySubscribedTo: [...this.state.alreadySubscribedTo, subscription.id],
    });
  };

  onSubscribing = () => {
    this.setState({ subscribing: true });
  };

  onClose = () => {
    this.setState({ subscribing: false, thanks: false });
  };

  onLeft = () => {
    const length = this.props.author.primary_contributor_for.length;
    this.setState({ index: (length + this.state.index - 1) % length });
  };

  onRight = () => {
    const length = this.props.author.primary_contributor_for.length;
    this.setState({ index: (this.state.index + 1) % length });
  };

  render() {
    const { author } = this.props;
    if (!author || !author.primary_contributor_for || author.primary_contributor_for.length === 0) return null;

    const subscriptions = author.primary_contributor_for.map((subscription) => {
      return {
        ...subscription,
        isSubscribed: this.state.alreadySubscribedTo.includes(subscription.id),
      };
    });

    const subscription = subscriptions[this.state.index];

    return (
      <div className={styles.root}>
        <div className={styles.featured}>{`${author.display_name}'s Newsletters`}</div>
        {
          (this.state.subscribing || this.state.thanks) ?
            <Icon
              className={styles.close}
              name="close"
              description="Cancel attempting to subscribe to author's newsletter"
              onClick={this.onClose}/> :
            <div>
              <Icon
                className={styles.left}
                name="caret/left"
                description="Move left through author's newsletters"
                onClick={this.onLeft}/>
              <Icon
                className={styles.right}
                name="caret/right"
                description="Move right through author's newsletters"
                onClick={this.onRight}/>
            </div>
        }
        <SubscribeToNewsletter
          subscription={subscription}
          subscribing={this.state.subscribing}
          thanks={this.state.thanks}
          onSubscribed={this.onSubscribed}
          onSubscribing={this.onSubscribing}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
    isLoggedIn: !!state.authDrawer.authToken, // TODO: implement this when user stuff is done
  };
};

AuthorSubscribe.propTypes = {
  user: PropTypes.object,
  author: PropTypes.object,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, { updateUnAuthedSubscriptions, updateUserSubscriptions })(AuthorSubscribe);
